import { Expose, Transform, Type } from 'class-transformer';
import { dateTransformer } from 'src/lib/utilities/api/class-transformer-types';
import {
	GradCoordinatorGradRequestModel,
	GradCoordinatorGradRequestModel_ClassTransform_Type,
} from '../../trackers/grad-coordinator-tracker.model';
import {
	StudentWithdrawRequestModel,
	StudentWithdrawRequestModel_ClassTransformType,
} from '../enrollment/student-withdraw.model';
import {
	StudentPauseRequestModel,
	StudentPauseRequestModel_ClassTransform_Type,
} from '../pause/students-pause.model';
import {
	StudentStatusEnrollmentEventsModel,
	StudentStatusEnrollmentEventsModel_ClassTransform_Type,
} from './student-status-enrollment-events.model';

// Sub Models
export class StudentStatusExitModel {
	code: string;
	code_title: string;
	text: string;
	category_id: string;
	category_title: string;
}

export enum StudentStatusExitCode {
	INACTIVE = 0,
	ACTIVE = 1,
	PENDING = 2,
}

export class StudentStatusEnrollmentModel {
	institute_id: number;
	status: StudentStatusExitCode;

	program_status: string;

	@Expose({ name: 'enrolled_timestamp' })
	@Transform(dateTransformer)
	enrolled_date: Date;

	@Expose({ name: 'activated_timestamp' })
	@Transform(dateTransformer)
	activated_date: Date;

	@Expose({ name: 'withdrawal_timestamp' })
	@Transform(dateTransformer)
	withdrawal_date: Date;

	@Type(StudentStatusExitModel_ClassTransform_Type)
	exit: StudentStatusExitModel;
}

export class StudentStatusPauseTimestampModel {
	@Transform(dateTransformer)
	on_timestamp: Date;
	by: string;
	by_name: string;
}

// Main Model
export class StudentStatusModel {
	@Type(StudentStatusEnrollmentModel_ClassTransform_Type)
	enrollment: StudentStatusEnrollmentModel;

	@Type(StudentStatusEnrollmentEventsModel_ClassTransform_Type)
	enrollment_events: StudentStatusEnrollmentEventsModel;

	@Transform(dateTransformer)
	graduated_date: Date;

	@Type(GradCoordinatorGradRequestModel_ClassTransform_Type)
	graduation_review: GradCoordinatorGradRequestModel;

	@Type(StudentPauseRequestModel_ClassTransform_Type)
	pause_request: StudentPauseRequestModel;

	@Type(StudentPauseRequestModel_ClassTransform_Type)
	pause_status: StudentPauseRequestModel;

	@Type(StudentWithdrawRequestModel_ClassTransformType)
	withdrawal_request: StudentWithdrawRequestModel;
}

// API Model

export function StudentStatusModel_ClassTransform_Type() {
	return StudentStatusModel;
}

export function StudentStatusEnrollmentModel_ClassTransform_Type() {
	return StudentStatusEnrollmentModel;
}
export function StudentStatusExitModel_ClassTransform_Type() {
	return StudentStatusExitModel;
}
export function StudentStatusPauseTimestampModel_ClassTransform_Type() {
	return StudentStatusPauseTimestampModel;
}
